import '../css/DynamicForm.css';
import React, { useState, useEffect } from "react";
import { Fetchexecutequery,Fetchupload } from '../../../services/process/BRS1/brsService7';
import axios from "axios";

const DynamicForm = ({ fields, formData, onInputChange, onSubmit }) => {
  const generateYearOptions = () => {
    const currentYear = new Date().getFullYear();
    const startYear = currentYear - 100;
    const endYear = currentYear + 100;
    return Array.from(new Array(endYear - startYear + 1), (v, i) => startYear + i);
  };
  const [dataDisplayers, setDataDisplayers] = useState({});
  const [fileUploads, setFileUploads] = useState({});


const validateField = (value, type) => {
    if (!type) return true; // If no type is defined, skip validation

    switch (type.value) {
        case "text":
            return true; // Allow any text input
        case "integer":
            return /^-?\d*$/.test(value); // Allow integers (positive or negative) and empty input for partial typing
        case "decimal":
            return /^-?\d*\.?\d*$/.test(value); // Allow numbers with optional decimal points
        case "date":
            return !isNaN(Date.parse(value)); // Validate as a valid date
        default:
            return true; // For unsupported types, skip validation
    }
};

const handleFileRemoval = (columnName) => {
  setFileUploads((prevState) => {
    const updatedState = { ...prevState };
    delete updatedState[columnName]; // Remove the file from the state
    return updatedState;
  });

  onInputChange(columnName, ""); // Reset form data for this column
};

const handleFileUpload = async (e, columnName,file_path) => {
    const file = e.target.files[0];
    if (file) {
        // Define the custom file path where the file should be saved
        const sharedFilePath = `${file_path}`;

        // Prepare the data to send
        const formData = new FormData();
        formData.append("file", file);
        formData.append("filePath", sharedFilePath);
        try {
            // Call the backend endpoint with the FormData
            const response = await fetch("http://154.61.75.209:1200/api/v2/user_modules/upload/", {
                method: 'POST', // Set the method explicitly
                body: formData, // Use formData as the body
                // Don't set Content-Type header, it will be set automatically by fetch
            });

            // Check if the response is OK (status 200)
            if (response.ok) {
                const data = await response.json(); // Parse the JSON response
                const backendFileName = data.Filename;

                // Update the local state with the file info and uploaded path
                setFileUploads((prevState) => ({
                    ...prevState,
                    [columnName]: {
                        fileName: backendFileName,
                        filePath: data.Filepath, // Assuming `Filepath` is returned in the response
                    },
                }));

                onInputChange(columnName, backendFileName);
            } else {
                // Handle error responses from the server
                const errorData = await response.json();
                console.error('Error uploading file:', errorData.Message || 'Unknown error');
            }
        } catch (error) {
            console.error("Error uploading file:", error);
        }
    }
};


  // Watch for changes in reference fields and update Data Displayer fields
useEffect(() => {
  if (fields && Array.isArray(fields)) {
    fields.forEach((field) => {
      if (field.function === 'Data Displayer with reference') {
        const referenceField = field.customOptions?.inputFieldDropdown2?.value;
        if (referenceField && formData[referenceField]) {
          fetchDataForDataDisplayer(referenceField, formData[referenceField], field.columnName, field.customOptions)
            .then((dataDisplayerValue) => {
              // Only update state if value has actually changed to prevent infinite loop
              if (dataDisplayers[field.columnName] !== dataDisplayerValue) {
                setDataDisplayers(prevState => ({
                  ...prevState,
                  [field.columnName]: dataDisplayerValue
                }));
                onInputChange(field.columnName, dataDisplayerValue);
              }
            });
        }
      }
    });
  }
}, [formData, fields, dataDisplayers]);  // Added `dataDisplayers` to dependencies



// Fetch data for Data Displayer based on reference field value
 const fetchDataForDataDisplayer = async (referenceField, referenceValue, columnName, customOptions) => {
  let payload = {
    query: `SELECT ${columnName} FROM ${customOptions.inputFieldDropdown.value}.${customOptions.inputFieldDropdown1.value} WHERE ${referenceField} = '${referenceValue}';`
  };

  var getProcessingLayerDataWithStatus = Fetchexecutequery();

  try {
    const response = await axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0]);
    const data = response.data;

    if (data && data.length > 0) {
      return data[0][columnName];
    } else {
      return 'No data found';
    }
  } catch (error) {
    console.error("Error fetching data for Data Displayer", error);
    return 'Error fetching data';
  }
};


  const formatFieldName = (name) => {
    return name.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const handleFieldChange = (e, fieldType) => {
    if (e && e.target) {
      const { name, value } = e.target;
        const isValid = validateField(value, fieldType);

        if (isValid) {
            onInputChange(name, value); // Update the form data if valid
        } else {
            console.error(`Invalid input for type ${fieldType?.value}:`, value);
            // Optionally, you can set an error message in the state for this field
            alert(`Invalid input for ${fieldType.label}. Please enter a valid ${fieldType.label.toLowerCase()}.`);
        }
      // onInputChange(name, value);
        e.target.style.height = "auto"; // Reset height
  	e.target.style.height = `${e.target.scrollHeight}px`; // Set height based on content

    } else {
      console.error("Event target is undefined", e);
    }
  };



  return (
    <form onSubmit={onSubmit} className="dynamic-form">
  {fields?.map((field, index) => {
    if (!field.function) return null;

    const renderField = () => {
      switch (field.function) {
        case 'Input Field':
          return (
            <textarea
              type="text"
              name={field.columnName}
              maxLength={field.maxDigits}
              value={formData[field.columnName] || ''}
              onChange={(e) => handleFieldChange(e, field.type)}
              style={{ resize: 'none', overflow: 'hidden' }}
            />
          );
        case 'Dropdown':
          return (
            <select
              name={field.columnName}
              value={formData[field.columnName] || ''}
              onChange={handleFieldChange}
            >
              <option value="" disabled>
                {`Select ${field.columnName.replace(/_/g, ' ')}`}
              </option>
              {field.options.map((option, idx) => (
                <option key={idx} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          );
        case 'Data Displayer with reference':
          return <span className="data-displayer-box">{dataDisplayers[field.columnName] || ''}</span>;
        case 'Data Displayer':
          return <span className="data-displayer-box">{formData[field.columnName] || ''}</span>;
        case "File Upload":
  return (
    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
      {/* File Upload Input */}
      <input
        type="file"
        name={field.columnName}
        onChange={(e) => handleFileUpload(e, field.columnName, field.customOptions.filePath)}
        style={{ display: formData[field.columnName] ? "none" : "block" }}
      />
      
      {/* Display File Name with Remove Option */}
      {formData[field.columnName] && (
        <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <a
            href={ field.customOptions.fileDownloadPath+`/${formData[field.columnName]}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "#007bff",
              textDecoration: "underline",
              cursor: "pointer",
            }}
          >
            {formData[field.columnName]}
          </a>
          <button
            type="button"
            onClick={() => {
              handleFileRemoval(field.columnName); // Function to remove/reset file
            }}
            style={{
              cursor: "pointer",
              background: "none",
              border: "none",
              color: "red",
              fontWeight: "bold",
            }}
          >
            X
          </button>
        </div>
      )}
    </div>
  );

case "File Displayer":
  return (
    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>      
      {/* Display File Name with Remove Option */}
      {formData[field.columnName] && (
        <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <a
            href={ field.customOptions.fileDownloadPath+`/${formData[field.columnName]}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "#007bff",
              textDecoration: "underline",
              cursor: "pointer",
            }}
          >
            {formData[field.columnName]}
          </a>
        </div>
      )}
    </div>
  );


        case 'Date Field':
          return (
            <>
              {field.dateFormat === 'month' ? (
                <input
                  type="month"
                  name={field.columnName}
                  value={formData[field.columnName] || ''}
                  onChange={handleFieldChange}
                />
              ) : field.dateFormat === 'year' ? (
                <select
                  name={field.columnName}
                  value={formData[field.columnName] || ''}
                  onChange={handleFieldChange}
                >
                  {generateYearOptions().map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
              ) : (
                <input
                  type="date"
                  name={field.columnName}
                  value={formData[field.columnName] || ''}
                  onChange={handleFieldChange}
                />
              )}
            </>
          );
        default:
          return null;
      }
    };


const widthClass = field.width ? `width-${field.width}` : 'width-ml';

return (
  <div key={index} className={`form-group ${widthClass}`}>
    <label className="form-label">{formatFieldName(field.columnName)}:</label>
    <div className="form-input">{renderField()}</div>
  </div>
);

  })}
</form>
  );
};

export default DynamicForm;
